import React from 'react';
import AnimateIn from './AnimateIn';
import './Vision.css';

const Vision = ({ title, mission, vision, values, valuesFour }) => {
  const defaultTitle = 'Our Vision & Mission';
  const defaultMission = 'To bridge the gap between knowledge and real-world application by delivering structured, industry-relevant, and outcome-driven learning experiences that build competence, confidence, and career readiness.';
  const defaultVision = 'To become a global catalyst for infinite growth by redefining education through skill-driven, future-ready learning that empowers individuals to unlock their highest potential.';
  const defaultValuesFour = [
    { title: 'Practical First', desc: 'Learn by doing. Our curriculum focuses on real-world scenarios and hands-on projects rather than just theory.' },
    { title: 'Industry Aligned', desc: 'Curriculum designed with input from top tech companies to ensure you learn exactly what employers are looking for.' },
    { title: 'Community Driven', desc: 'Grow alongside peers, mentors, and industry experts in a supportive environment that fosters collaboration.' },
    { title: 'Outcome Focused', desc: 'Every program is designed to build real competence and measurable results for your career growth.' },
  ];
  const defaultValues = [
    { number: '1', label: 'Outcome Over Data', desc: 'We believe learning must lead to results. Every program is designed to build real competence, not just theoretical knowledge.' },
    { number: '2', label: 'Industry Relevance', desc: 'Our training evolves with the market. We focus on skills that employers demand today and will value tomorrow.' },
    { number: '3', label: 'Hands-On Mastery', desc: 'Understanding is not enough. We prioritize practical application, live projects, and real-world exposure.' },
    { number: '4', label: 'Growth Mindset', desc: 'We nurture confidence, adaptability, and continuous improvement — because true success begins with mindset.' },
    { number: '5', label: 'Infinite Potential', desc: 'We believe every individual has limitless capacity to grow. Our role is to unlock, guide, and accelerate that journey.' },
  ];

  const valueList = values || defaultValues;
  const valueListFour = valuesFour || defaultValuesFour;

  const missionText = mission || defaultMission;
  const visionText = vision || defaultVision;

  return (
    <section className="vision" id="vision">
      <div className="vision-container">
        <AnimateIn direction="up">
          <h2 className="vision-title">{title || defaultTitle}</h2>
        </AnimateIn>

        {/* Previous / simple Mission & Vision – two cards side by side */}
        <div className="vision-mission-simple">
        <AnimateIn direction="right" className="vision-simple-card vision-simple-vision" delay={100}>
            <h3 className="vision-simple-card-title">Vision</h3>
            <p className="vision-simple-card-text">{visionText}</p>
          </AnimateIn>
          <AnimateIn direction="left" className="vision-simple-card vision-simple-mission">
            <h3 className="vision-simple-card-title">Mission</h3>
            <p className="vision-simple-card-text">{missionText}</p>
          </AnimateIn>
         
        </div>

        {/* Staggered Vision & Mission – commented out; Core Values follows simple section as before */}
        {/* <div className="vision-mission-block">
          <AnimateIn direction="left" className="vision-capsule vision-capsule-left">
            <div className="vision-capsule-icon" aria-hidden="true">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                <circle cx="12" cy="12" r="3" />
              </svg>
            </div>
            <h3 className="vision-capsule-title">Vision</h3>
            <p className="vision-capsule-text">{visionText}</p>
          </AnimateIn>
          <div className="vision-center-image">
            <img src="https://images.unsplash.com/photo-1522071820081-009f0129c71c?w=400&q=80" alt="Team collaboration" />
          </div>
          <AnimateIn direction="right" className="vision-capsule vision-capsule-right" delay={100}>
            <div className="vision-capsule-icon vision-capsule-icon-target" aria-hidden="true">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="12" cy="12" r="10" />
                <circle cx="12" cy="12" r="6" />
                <circle cx="12" cy="12" r="2" />
              </svg>
            </div>
            <h3 className="vision-capsule-title">Mission</h3>
            <p className="vision-capsule-text">{missionText}</p>
          </AnimateIn>
        </div> */}

        {/* Previous values section – 4 small cards, 4 columns, no heading */}
        {/* <div className="vision-values-four">
          <div className="vision-values-four-grid">
            {valueListFour.map((item, i) => (
              <AnimateIn key={i} direction={i % 2 === 0 ? 'left' : 'right'} className="vision-values-four-card" delay={i * 80}>
                <h4 className="vision-values-four-card-title">{item.title}</h4>
                <p className="vision-values-four-card-desc">{item.desc}</p>
              </AnimateIn>
            ))}
          </div>
        </div> */}

        <div className="vision-values">
          <h3 className="vision-values-title">
            <span className="vision-values-title-icon" aria-hidden="true">🎯</span>
            Core Values – 5 Pillars of InfinySkills
          </h3>
          <div className="vision-values-grid">
            {valueList.map((item, i) => (
              <AnimateIn key={i} direction={i % 2 === 0 ? 'left' : 'right'} className="vision-value-card" delay={i * 80}>
                {item.number && <span className="vision-value-number">{item.number}</span>}
                <span className="vision-value-label">{item.label}</span>
                <p className="vision-value-desc">{item.desc}</p>
              </AnimateIn>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Vision;
